import { createConfig } from './defaults';

export const environment = createConfig({
    name: 'vds-prod',
    domain: 'maps.vandersat.com',
    planetAuthServer: 'https://login.planet.com',
    planetAuthClientId: 'XIcqntGaQ1kziqZWy3vZCOagk7WECWRR',
});
